// cookie
export const COOKIE_TOKEN = 'token'

// storage
export const STORAGE_LNG = 'jca098u342n'
export const STORAGE_TAB_ID = 'tabid'
export const STORAGE_SUBTAB_ID = 'subtabid'
export const STORAGE_SSUB_ID = 'ssubid'
export const STORAGE_USER_PROFILE = 'joa**(hvj'
export const STORAGE_USER_PATHNAME = 'asdfjo'

// http status code
export const HTTP_422 = 422
export const HTTP_401 = 401

// api status
export const STATUS_API_SENT = 'passwords.sent'
export const STATUS_API_RESET = 'passwords.reset'


export const filters = {
    so: [
        { "field": "service_categories", "operator": "NOT_FIND_IN_SET_BUT", "value": ["hongkong,BVI,cayman,seychelles", "value_added_service"] },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "serviced_office" }
    ],
    vo: [
        { "field": "service_categories", "operator": "NOT_FIND_IN_SET_BUT", "value": ["hongkong,BVI,cayman,seychelles", "value_added_service"] },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "virtual_office" }
    ],
    hk_l: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "hongkong" },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "limited_company" }
    ],
    hk_ul: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "hongkong" },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "unlimited_company" }
    ],
    os_bvi: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "BVI" }
    ],
    os_cayman: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "cayman" }
    ],
    os_seychelles: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "seychelles" }
    ],
    recharge: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "recharge" },
    ],
    except_recharge: [
        { "field": "service_categories", "operator": "NOT_LIKE", "value": "recharge" }
    ],
    as_proxy: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "accounting_service" },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "accounting_proxy" }
    ],
    as_tax: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "accounting_service" },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "tax_return" }
    ],
    va_company_secretary: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "value_added_service" },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "company_secretary" }
    ],
    va_trademark_registration: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "value_added_service" },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "trademark_registration" }
    ],
    va_bank_account_registration: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "value_added_service" },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "bank_account_registration" }
    ],
    va_business_name_card: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "value_added_service" },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "business_name_card" }
    ],
    va_business_email: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "value_added_service" },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "business_email" }
    ],
    va_customized_seal: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "value_added_service" },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "customized_seal" }
    ],
    company_secretary_annual_return_service: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "company_secretary" },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "annual_return_service" }
    ],
    company_secretary_company_secretary_services: [
        { "field": "service_categories", "operator": "FIND_IN_SET", "value": "company_secretary" },
        { "field": "service_subcategories", "operator": "FIND_IN_SET", "value": "company_secretary_services" }
    ],
}

// export let service_filter = {
//     so: 'serviced_office',
//     vo: 'virtual_office',
//     hk_l: 'hongkong.limited_company',
//     hk_ul: 'hongkong.unlimited_company',
//     os_bvi: 'BVI.limited_company',
//     os_cayman: 'cayman.limited_company',
//     os_seychelles: 'seychelles.limited_company',
//     as_proxy: 'accounting_service.accounting_proxy',
//     as_tax: 'accounting_service.tax_return',
//     va_company_secretary: 'value_added_service.company_secretary',
//     va_trademark_registration: 'value_added_service.trademark_registration',
//     va_bank_account_registration: 'value_added_service.bank_account_registration',
//     va_business_name_card: 'value_added_service.business_name_card',
//     va_business_email: 'value_added_service.business_email',
//     va_customized_seal: 'value_added_service.customized_seal',
//     cs_cs: 'company_secretary.company_secretary_services',
//     cs_ay: 'company_secretary.annual_return_service',
// }
// export let service_filter = {
//     "recharge.fixed_amount.hkd3000": "recharge.fixed_amount.hkd3000",
//     "recharge.fixed_amount.hkd2000": "recharge.fixed_amount.hkd2000",
//     "recharge.fixed_amount.hkd1000": "recharge.fixed_amount.hkd1000",
//     "recharge.fixed_amount.hkd500": "recharge.fixed_amount.hkd500",
//     "recharge.fixed_amount.hkd200": "recharge.fixed_amount.hkd200",
//     "recharge.fixed_amount.hkd100": "recharge.fixed_amount.hkd100",
//     "accounting_service.accounting_proxy": "accounting_service.accounting_proxy",
//     "accounting_service.tax_return": "accounting_service.tax_return",
//     "value_added_service.virtual_office.package_b": "value_added_service.virtual_office.package_b",
//     "value_added_service.virtual_office.package_a": "value_added_service.virtual_office.package_a",
//     "value_added_service.serviced_office.nop_4": "value_added_service.serviced_office.nop_4",
//     "value_added_service.serviced_office.nop_3": "value_added_service.serviced_office.nop_3",
//     "value_added_service.serviced_office.nop_2": "value_added_service.serviced_office.nop_2",
//     "value_added_service.serviced_office.nop_1": "value_added_service.serviced_office.nop_1",
//     "value_added_service.trademark_registration": "value_added_service.trademark_registration",
//     "value_added_service.bank_account_registration": "value_added_service.bank_account_registration",
//     "value_added_service.business_email": "value_added_service.business_email",
//     "value_added_service.customized_seal.authorized_signature": "value_added_service.customized_seal.authorized_signature",
//     "value_added_service.customized_seal.company_chop": "value_added_service.customized_seal.company_chop",
//     "value_added_service.business_name_card_200": "value_added_service.business_name_card_200",
//     "value_added_service.business_name_card_100": "value_added_service.business_name_card_100",
//     "company_secretary.annual_return_service": "company_secretary.annual_return_service",
//     "company_secretary.company_secretary_services": "company_secretary.company_secretary_services",
//     "seychelles.limited_company.package_b": "seychelles.limited_company.package_b",
//     "seychelles.limited_company.package_a": "seychelles.limited_company.package_a",
//     "cayman.limited_company.package_b": "cayman.limited_company.package_b",
//     "cayman.limited_company.package_a": "cayman.limited_company.package_a",
//     "BVI.limited_company.package_b": "BVI.limited_company.package_b",
//     "BVI.limited_company.package_a": "BVI.limited_company.package_a",
//     "hongkong.limited_company.package_c": "hongkong.limited_company.package_c",
//     "hongkong.limited_company.package_b": "hongkong.limited_company.package_b",
//     "hongkong.limited_company.package_a": "hongkong.limited_company.package_a"
// }
// export let service_filter = {
//     "recharge": "fixed_amount",
//     "accounting_service": "tax_return",
//     "value_added_service": "business_name_card_100",
//     "company_secretary": "company_secretary_services",
//     "seychelles": "limited_company",
//     "cayman": "limited_company",
//     "BVI": "limited_company",
//     "hongkong": "limited_company"
// }
// export let service_filter = {
//     "recharge": "recharge.fixed_amount",
//     "accounting_service": "accounting_service.tax_return",
//     "value_added_service": "value_added_service.business_name_card_100",
//     "company_secretary": "company_secretary.company_secretary_services",
//     "seychelles": "seychelles.limited_company",
//     "cayman": "cayman.limited_company",
//     "BVI": "BVI.limited_company",
//     "hongkong": "hongkong.limited_company"
// }
export let service_filter = {
    "recharge": {
        "fixed_amount": {
            "hkd3000": "recharge.fixed_amount.hkd3000",
            "hkd2000": "recharge.fixed_amount.hkd2000",
            "hkd1000": "recharge.fixed_amount.hkd1000",
            "hkd500": "recharge.fixed_amount.hkd500",
            "hkd200": "recharge.fixed_amount.hkd200",
            "hkd100": "recharge.fixed_amount.hkd100"
        }
    },
    "accounting_service": {
        "accounting_proxy": "accounting_service.accounting_proxy",
        "tax_return": "accounting_service.tax_return"
    },
    "value_added_service": {
        "virtual_office": {
            "package_b": "value_added_service.virtual_office.package_b",
            "package_a": "value_added_service.virtual_office.package_a"
        },
        "serviced_office": {
            "nop_4": "value_added_service.serviced_office.nop_4",
            "nop_3": "value_added_service.serviced_office.nop_3",
            "nop_2": "value_added_service.serviced_office.nop_2",
            "nop_1": "value_added_service.serviced_office.nop_1"
        },
        "trademark_registration": "value_added_service.trademark_registration",
        "bank_account_registration": "value_added_service.bank_account_registration",
        "business_email": "value_added_service.business_email",
        "customized_seal": {
            "authorized_signature": "value_added_service.customized_seal.authorized_signature",
            "company_chop": "value_added_service.customized_seal.company_chop"
        },
        "business_name_card_200": "value_added_service.business_name_card_200",
        "business_name_card_100": "value_added_service.business_name_card_100"
    },
    "company_secretary": {
        "annual_return_service": "company_secretary.annual_return_service",
        "company_secretary_services": "company_secretary.company_secretary_services"
    },
    "seychelles": {
        "limited_company": {
            "package_b": "seychelles.limited_company.package_b",
            "package_a": "seychelles.limited_company.package_a"
        }
    },
    "cayman": {
        "limited_company": {
            "package_b": "cayman.limited_company.package_b",
            "package_a": "cayman.limited_company.package_a"
        }
    },
    "BVI": {
        "limited_company": {
            "package_b": "BVI.limited_company.package_b",
            "package_a": "BVI.limited_company.package_a"
        }
    },
    "hongkong": {
        "limited_company": {
            "package_c": "hongkong.limited_company.package_c",
            "package_b": "hongkong.limited_company.package_b",
            "package_a": "hongkong.limited_company.package_a"
        }
    }
}

export let resp_service_filter = new Proxy(
    {
        value: service_filter
    }, {
    get(target, prop, rx) {
        return target
    },
    set(target, prop, newVal) {
        target[prop] = newVal
        return true
    }
})

export let services = [
    {
        "id": 32,
        "service_category_id": 10,
        "service_subcategory_id": 17,
        "name": "recharge.fixed_amount.hkd3000",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "增值3000元",
        "content_tc": "增值3000元",
        "content_cn": "增值3000元",
        "price": 3000,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 3000,
        "locale_name": "Recharge - $3000",
        "service_category": {
            "id": 10,
            "name": "recharge",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 17,
            "name": "fixed_amount",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 31,
        "service_category_id": 10,
        "service_subcategory_id": 17,
        "name": "recharge.fixed_amount.hkd2000",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "增值2000元",
        "content_tc": "增值2000元",
        "content_cn": "增值2000元",
        "price": 2000,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 2000,
        "locale_name": "Recharge - $2000",
        "service_category": {
            "id": 10,
            "name": "recharge",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 17,
            "name": "fixed_amount",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 30,
        "service_category_id": 10,
        "service_subcategory_id": 17,
        "name": "recharge.fixed_amount.hkd1000",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "增值1000元",
        "content_tc": "增值1000元",
        "content_cn": "增值1000元",
        "price": 1000,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 1000,
        "locale_name": "Recharge - $1000",
        "service_category": {
            "id": 10,
            "name": "recharge",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 17,
            "name": "fixed_amount",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 29,
        "service_category_id": 10,
        "service_subcategory_id": 17,
        "name": "recharge.fixed_amount.hkd500",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "增值500元",
        "content_tc": "增值500元",
        "content_cn": "增值500元",
        "price": 500,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 500,
        "locale_name": "Recharge - $500",
        "service_category": {
            "id": 10,
            "name": "recharge",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 17,
            "name": "fixed_amount",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 28,
        "service_category_id": 10,
        "service_subcategory_id": 17,
        "name": "recharge.fixed_amount.hkd200",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "增值200元",
        "content_tc": "增值200元",
        "content_cn": "增值200元",
        "price": 200,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 200,
        "locale_name": "Recharge - $200",
        "service_category": {
            "id": 10,
            "name": "recharge",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 17,
            "name": "fixed_amount",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 27,
        "service_category_id": 10,
        "service_subcategory_id": 17,
        "name": "recharge.fixed_amount.hkd100",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "增值100元",
        "content_tc": "增值100元",
        "content_cn": "增值100元",
        "price": 100,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 100,
        "locale_name": "Recharge - $100",
        "service_category": {
            "id": 10,
            "name": "recharge",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 17,
            "name": "fixed_amount",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 26,
        "service_category_id": 6,
        "service_subcategory_id": 14,
        "name": "accounting_service.accounting_proxy",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "代理會計",
        "content_tc": "代理會計",
        "content_cn": "代理會計",
        "price": 0,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 0,
        "locale_name": "Accounting proxy",
        "service_category": {
            "id": 6,
            "name": "accounting_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 14,
            "name": "accounting_proxy",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 25,
        "service_category_id": 6,
        "service_subcategory_id": 13,
        "name": "accounting_service.tax_return",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "會計服稅",
        "content_tc": "會計服稅",
        "content_cn": "會計服稅",
        "price": 0,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 0,
        "locale_name": "Tax return",
        "service_category": {
            "id": 6,
            "name": "accounting_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 13,
            "name": "tax_return",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 24,
        "service_category_id": 5,
        "service_subcategory_id": 16,
        "name": "value_added_service.virtual_office.package_b",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "Includes all services of Package A and\nA dedicated person will answer the call and notify you via email\nReceive fax",
        "content_tc": "包括 A 套餐所有服務及\n專人接聽電話後電郵通知\n接收傳真",
        "content_cn": "包括 A 套餐所有服务及\n专人接听电话后电邮通知\n接收传真",
        "price": 4800,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 4800,
        "locale_name": "Virtual Office - Package B",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 16,
            "name": "virtual_office",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 23,
        "service_category_id": 5,
        "service_subcategory_id": 16,
        "name": "value_added_service.virtual_office.package_a",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "Provide a valid business address\nCollect company letters/packages on behalf of the company\nChange business registration certificate address for free\nFree accounting service consultation",
        "content_tc": "提供有效的商業地址\n代收公司信件/包裹\n免費更改商業登記證地址\n免費會計服務咨詢",
        "content_cn": "提供有效的商业地址\n代收公司信件/包裹\n免费更改商业登记证地址\n免费会计服务咨询",
        "price": 2400,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 2400,
        "locale_name": "Virtual Office - Package A",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 16,
            "name": "virtual_office",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 22,
        "service_category_id": 5,
        "service_subcategory_id": 15,
        "name": "value_added_service.serviced_office.nop_4",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "服務式辦公室 4人工作間",
        "content_tc": "服務式辦公室 4人工作間",
        "content_cn": "服務式辦公室 4人工作間",
        "price": 0,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 0,
        "locale_name": "Workspace for 4 persons",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 15,
            "name": "serviced_office",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 21,
        "service_category_id": 5,
        "service_subcategory_id": 15,
        "name": "value_added_service.serviced_office.nop_3",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "服務式辦公室 3人工作間",
        "content_tc": "服務式辦公室 3人工作間",
        "content_cn": "服務式辦公室 3人工作間",
        "price": 0,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 0,
        "locale_name": "Workspace for 3 persons",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 15,
            "name": "serviced_office",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 20,
        "service_category_id": 5,
        "service_subcategory_id": 15,
        "name": "value_added_service.serviced_office.nop_2",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "服務式辦公室 2人工作間",
        "content_tc": "服務式辦公室 2人工作間",
        "content_cn": "服務式辦公室 2人工作間",
        "price": 0,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 0,
        "locale_name": "Workspace for 2 persons",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 15,
            "name": "serviced_office",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 19,
        "service_category_id": 5,
        "service_subcategory_id": 15,
        "name": "value_added_service.serviced_office.nop_1",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "服務式辦公室 1人工作間",
        "content_tc": "服務式辦公室 1人工作間",
        "content_cn": "服務式辦公室 1人工作間",
        "price": 0,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 0,
        "locale_name": "Workspace for 1 person",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 15,
            "name": "serviced_office",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 18,
        "service_category_id": 5,
        "service_subcategory_id": 10,
        "name": "value_added_service.trademark_registration",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "trademark registration",
        "content_tc": "註冊商標",
        "content_cn": "注册商标",
        "price": 0,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 0,
        "locale_name": "Trademark registration",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 10,
            "name": "trademark_registration",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 17,
        "service_category_id": 5,
        "service_subcategory_id": 9,
        "name": "value_added_service.bank_account_registration",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "bank account registration",
        "content_tc": "註冊銀行賬戶",
        "content_cn": "注册银行账户",
        "price": 0,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 0,
        "locale_name": "Bank account registration",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 9,
            "name": "bank_account_registration",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 16,
        "service_category_id": 5,
        "service_subcategory_id": 6,
        "name": "value_added_service.business_email",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "business email",
        "content_tc": "企業電郵",
        "content_cn": "企业电邮",
        "price": 0,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 0,
        "locale_name": "Business email",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 6,
            "name": "business_email",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 15,
        "service_category_id": 5,
        "service_subcategory_id": 8,
        "name": "value_added_service.customized_seal.authorized_signature",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "authorized signature",
        "content_tc": "簽字章",
        "content_cn": "签字章",
        "price": 230,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 230,
        "locale_name": "Authorized signature",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 8,
            "name": "customized_seal",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 14,
        "service_category_id": 5,
        "service_subcategory_id": 8,
        "name": "value_added_service.customized_seal.company_chop",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "company chop",
        "content_tc": "圓章",
        "content_cn": "圆章",
        "price": 130,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 130,
        "locale_name": "Company chop",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 8,
            "name": "customized_seal",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 13,
        "service_category_id": 5,
        "service_subcategory_id": 7,
        "name": "value_added_service.business_name_card_200",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "卡片印刷 200 張（2 盒）",
        "content_tc": "卡片印刷 200 張（2 盒）",
        "content_cn": "卡片印刷 200 張（2 盒）",
        "price": 350,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 350,
        "locale_name": "Business name card (200 pcs)",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 7,
            "name": "business_name_card",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 12,
        "service_category_id": 5,
        "service_subcategory_id": 7,
        "name": "value_added_service.business_name_card_100",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "卡片印刷 100 張（1 盒）",
        "content_tc": "卡片印刷 100 張（1 盒）",
        "content_cn": "卡片印刷 100 張（1 盒）",
        "price": 200,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 200,
        "locale_name": "Business name card (100 pcs)",
        "service_category": {
            "id": 5,
            "name": "value_added_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 7,
            "name": "business_name_card",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 11,
        "service_category_id": 7,
        "service_subcategory_id": 12,
        "name": "company_secretary.annual_return_service",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "Prepare and submit annual return (AR) on time excludes government fees (government fees will be reimbursed)\n* Customers need to cooperate with the company’s establishment date as soon as possible Sign back. If submission is late due to customer concerns, Any fines incurred will be borne by the guests themselves",
        "content_tc": "準備及按時提交周年申報表(AR) 不包括政府費(政府費將實報實銷)\n* 客人需配合公司的成立日，儘快簽回檔。如因客人的關像而遲交，所產生的罰款將由客人自行承相",
        "content_cn": "准备及按时提交周年申报表(AR) 不包括政府费(政府费将实报实销)\n* 客人需配合公司的成立日，尽快签回档。如因客人的关像而迟交，所产生的罚款将由客人自行承相",
        "price": 800,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 800,
        "locale_name": "Annual return service",
        "service_category": {
            "id": 7,
            "name": "company_secretary",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 12,
            "name": "annual_return_service",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 10,
        "service_category_id": 7,
        "service_subcategory_id": 11,
        "name": "company_secretary.company_secretary_services",
        "service_fees": null,
        "service_period": null,
        "service_payload": null,
        "content_en": "Services include :\nParticipate as company secretary until the next anniversary of its incorporation\nPrepare and submit on time annual return (NAR1) for the same year",
        "content_tc": "出任公司秘書一職至責公司本年度結束日\n準備及按時提交同一年度的周年申報表 (NAR1)",
        "content_cn": "出任公司秘书一职至责公司本年度结束日\n准备及按时提交同一年度的周年申报表 (NAR1)",
        "price": 3500,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 3500,
        "locale_name": "Company secretary services",
        "service_category": {
            "id": 7,
            "name": "company_secretary",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 11,
            "name": "company_secretary_services",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 9,
        "service_category_id": 4,
        "service_subcategory_id": 1,
        "name": "seychelles.limited_company.package_b",
        "service_fees": [
            {
                "text": "Provision of registered office",
                "fee": 5800
            },
            {
                "text": "Provision of registered agent",
                "fee": 4110
            },
            {
                "text": "BVI Government license fee",
                "fee": 4318
            },
            {
                "text": "Economic Substance Annual Reporting for BVI company @if(!empty($esar_year)) in {{ $esar_year }} @endif",
                "fee": 3000
            },
            {
                "text": "Annual return fee",
                "fee": 2000
            }
        ],
        "service_period": "@if(!empty($start_date) && !empty($end_date))\nTo Professional Service rendered as follows : -\nCompany incorporated in British Virgin Islands Annual fee for the period from {{ $start_date }} to {{ $end_date }}\n@endif",
        "service_payload": null,
        "content_en": "Establishment of a brand new Seychelles company\nDetails\nCheck company name (Chinese and English names)\nPrepare and submit relevant documents\nProvide Seychelles registered address\nSeychelles company registration agency (one year)\nCompany registration certificate\nCompany directors, shareholders and key personnel list\nCompany Articles of Association (6 copies)\nCompany blank stock certificates (10 copies)\nMake company seal (metal steel seal, signature seal)\nCompany document box (One Box)\n\nSeychelles government fees included\n\nIt includes a notarization fee for both Chinese and English names. If the lawyer fails, additional name creation and notarization fees of HKD$2,000 will be required.",
        "content_tc": "成立全新塞舌爾公司\n服務內容包含：\n查冊公司名稱（中英文名稱）\n準備及提交有關文件\n提供塞舌爾註冊地址\n塞舌爾公司註冊代理（一年）\n公司註冊登記證\n公司董事、股東及要員名冊\n公司章程(6本)\n公司空白股票正本（10張）\n製作公司印章（金屬鋼章、簽字章）\n公司文件盒（一個）\n\n已包含塞舌爾政府費用",
        "content_cn": "成立全新塞舌尔公司\n服務內容包含：\n查册公司名称（中英文名称）\n准备及提交有关文件\n提供开曼注册地址\n开曼公司注册代理（一年）\n公司注册登记证\n公司董事、股东及要员名册\n公司章程(6本)\n公司空白股票正本（10张）\n制作公司印章（金属钢章、签字章）\n公司文件盒（一个）\n\n已包含塞舌尔政府费用\n\n包含一次中英文名称同义公证费，如律师不通过则需另起名及公证费HKD$2,000",
        "price": 22680,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 22680,
        "locale_name": "Seychelles limited company - Package B",
        "service_category": {
            "id": 4,
            "name": "seychelles",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 1,
            "name": "limited_company",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 8,
        "service_category_id": 4,
        "service_subcategory_id": 1,
        "name": "seychelles.limited_company.package_a",
        "service_fees": [
            {
                "text": "Provision of registered office",
                "fee": 5800
            },
            {
                "text": "Provision of registered agent",
                "fee": 4110
            },
            {
                "text": "BVI Government license fee",
                "fee": 4318
            },
            {
                "text": "Economic Substance Annual Reporting for BVI company @if(!empty($esar_year)) in {{ $esar_year }} @endif",
                "fee": 3000
            },
            {
                "text": "Annual return fee",
                "fee": 2000
            }
        ],
        "service_period": "@if(!empty($start_date) && !empty($end_date))\nTo Professional Service rendered as follows : -\nCompany incorporated in British Virgin Islands Annual fee for the period from {{ $start_date }} to {{ $end_date }}\n@endif",
        "service_payload": null,
        "content_en": "Buy a existing Seychelles Company\nDetails\nSearch company name (English name)\nPrepare and submit relevant documents\nProvide Seychelles registered address\nSeychelles company registration agent (one year)\nCompany registration certificate\nList of Directors, Shareholders and key personnel of the company\nArticles of Association (6 copies)\nOriginal blank company stock certificates (10 sheets)\nProduction of company seal (metal steel seal, signature seal)\nCompany document box (One Box)\n\nSeychelles government fees included",
        "content_tc": "購買現成塞舌爾公司\n服務內容包含：\n查冊公司名稱（英文名稱）\n準備及提交有關文件\n提供塞舌爾註冊地址\n塞舌爾公司註冊代理（一年）\n公司註冊登記證\n公司董事、股東及要員名冊\n公司章程(6本)\n公司空白股票正本（10張）\n製作公司印章（金屬鋼章、簽字章）\n公司文件盒（一個）\n\n已包含塞舌爾政府費用",
        "content_cn": "购买现成塞舌尔公司\n服務內容包含：\n查册公司名称（英文名称）\n准备及提交有关文件\n提供塞舌尔注册地址\n塞舌尔公司注册代理（一年）\n公司注册登记证\n公司董事、股东及要员名册\n公司章程(6本)\n公司空白股票正本（10张）\n制作公司印章（金属钢章、签字章）\n公司文件盒（一个）\n\n已包含塞舌尔政府费用",
        "price": 21680,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 21680,
        "locale_name": "Seychelles limited company - Package A",
        "service_category": {
            "id": 4,
            "name": "seychelles",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 1,
            "name": "limited_company",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 7,
        "service_category_id": 3,
        "service_subcategory_id": 1,
        "name": "cayman.limited_company.package_b",
        "service_fees": [
            {
                "text": "Provision of registered office",
                "fee": 5800
            },
            {
                "text": "Provision of registered agent",
                "fee": 4110
            },
            {
                "text": "BVI Government license fee",
                "fee": 4318
            },
            {
                "text": "Economic Substance Annual Reporting for BVI company @if(!empty($esar_year)) in {{ $esar_year }} @endif",
                "fee": 3000
            },
            {
                "text": "Annual return fee",
                "fee": 2000
            }
        ],
        "service_period": "@if(!empty($start_date) && !empty($end_date))\nTo Professional Service rendered as follows : -\nCompany incorporated in British Virgin Islands Annual fee for the period from {{ $start_date }} to {{ $end_date }}\n@endif",
        "service_payload": null,
        "content_en": "Establishment of a brand new Seychelles company\nDetails\nCheck company name (Chinese and English names)\nPrepare and submit relevant documents\nProvide Seychelles registered address\nSeychelles company registration agency (one year)\nCompany registration certificate\nCompany directors, shareholders and key personnel list\nCompany Articles of Association (6 copies)\nCompany blank stock certificates (10 copies)\nMake company seal (metal steel seal, signature seal)\nCompany document box (One Box)\n\nCayman government fees included\n\nIt includes a notarization fee for both Chinese and English names. If the lawyer fails, additional name creation and notarization fees of HKD$2,000 will be required.",
        "content_tc": "成立全新塞舌爾公司\n服務內容包含：\n查冊公司名稱（中英文名稱）\n準備及提交有關文件\n提供塞舌爾註冊地址\n塞舌爾公司註冊代理（一年）\n公司註冊登記證\n公司董事、股東及要員名冊\n公司章程(6本)\n公司空白股票正本（10張）\n製作公司印章（金屬鋼章、簽字章）\n公司文件盒（一個）\n\n已包含開曼政府費用\n\n包含一次中英文名稱同義公證費，如律師不通過則需另起名及公證費HKD$2,000",
        "content_cn": "成立全新塞舌尔公司\n服務內容包含：\n查册公司名称（中英文名称）\n准备及提交有关文件\n提供开曼注册地址\n开曼公司注册代理（一年）\n公司注册登记证\n公司董事、股东及要员名册\n公司章程(6本)\n公司空白股票正本（10张）\n制作公司印章（金属钢章、签字章）\n公司文件盒（一个）\n\n已包含開曼政府費用\n\n包含一次中英文名称同义公证费，如律师不通过则需另起名及公证费HKD$2,000",
        "price": 38810,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 38810,
        "locale_name": "Cayman limited company - Package B",
        "service_category": {
            "id": 3,
            "name": "cayman",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 1,
            "name": "limited_company",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 6,
        "service_category_id": 3,
        "service_subcategory_id": 1,
        "name": "cayman.limited_company.package_a",
        "service_fees": [
            {
                "text": "Provision of registered office",
                "fee": 5800
            },
            {
                "text": "Provision of registered agent",
                "fee": 4110
            },
            {
                "text": "BVI Government license fee",
                "fee": 4318
            },
            {
                "text": "Economic Substance Annual Reporting for BVI company @if(!empty($esar_year)) in {{ $esar_year }} @endif",
                "fee": 3000
            },
            {
                "text": "Annual return fee",
                "fee": 2000
            }
        ],
        "service_period": "@if(!empty($start_date) && !empty($end_date))\nTo Professional Service rendered as follows : -\nCompany incorporated in British Virgin Islands Annual fee for the period from {{ $start_date }} to {{ $end_date }}\n@endif",
        "service_payload": null,
        "content_en": "Buy a existing Seychelles Company\nDetails\nSearch company name (English name)\nPrepare and submit relevant documents\nProvide Seychelles registered address\nSeychelles company registration agent (one year)\nCompany registration certificate\nList of Directors, Shareholders and key personnel of the company\nArticles of Association (6 copies)\nOriginal blank company stock certificates (10 sheets)\nProduction of company seal (metal steel seal, signature seal)\nCompany document box (One Box)\n\nCayman government fees included",
        "content_tc": "購買現成塞舌爾公司\n服務內容包含：\n查冊公司名稱（英文名稱）\n準備及提交有關文件\n提供塞舌爾註冊地址\n塞舌爾公司註冊代理（一年）\n公司註冊登記證\n公司董事、股東及要員名冊\n公司章程(6本)\n公司空白股票正本（10張）\n製作公司印章（金屬鋼章、簽字章）\n公司文件盒（一個）\n\n已包含開曼政府費用",
        "content_cn": "购买现成塞舌尔公司\n服務內容包含：\n查册公司名称（英文名称）\n准备及提交有关文件\n提供塞舌尔注册地址\n塞舌尔公司注册代理（一年）\n公司注册登记证\n公司董事、股东及要员名册\n公司章程(6本)\n公司空白股票正本（10张）\n制作公司印章（金属钢章、签字章）\n公司文件盒（一个）\n\n已包含開曼政府費用",
        "price": 37810,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 37810,
        "locale_name": "Cayman limited company - Package A",
        "service_category": {
            "id": 3,
            "name": "cayman",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 1,
            "name": "limited_company",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 5,
        "service_category_id": 2,
        "service_subcategory_id": 1,
        "name": "BVI.limited_company.package_b",
        "service_fees": [
            {
                "text": "Provision of registered office",
                "fee": 5800
            },
            {
                "text": "Provision of registered agent",
                "fee": 4110
            },
            {
                "text": "BVI Government license fee",
                "fee": 4318
            },
            {
                "text": "Economic Substance Annual Reporting for BVI company @if(!empty($esar_year)) in {{ $esar_year }} @endif",
                "fee": 3000
            },
            {
                "text": "Annual return fee",
                "fee": 2000
            }
        ],
        "service_period": "@if(!empty($start_date) && !empty($end_date))\nTo Professional Service rendered as follows : -\nCompany incorporated in British Virgin Islands Annual fee for the period from {{ $start_date }} to {{ $end_date }}\n@endif",
        "service_payload": null,
        "content_en": "Establishment of a brand new British Virgin Islands company\nDetails\nSearch company name (English name)\nProvide BVI registered address\nBVI company registration agent (one year)\nCompany registration certificate\nList of Directors, Shareholders and key personnel of the company\nArticles of Association (6 copies)\nOriginal blank company stock certificates (10 sheets)\nProduction of company seal (metal steel seal, signature seal)\nCompany document box (One Box)\n\nBVI government fees included",
        "content_tc": "成立全新英屬處女島公司\n服務內容包含：\n查冊公司名稱（英文名稱）\n提供BVI註冊地址\nBVI公司註冊代理（一年）\n公司註冊登記證\n公司董事、股東及要員名冊\n公司章程(6本)\n公司空白股票正本（10張）\n製作公司印章（金屬鋼章、簽字章）\n公司文件盒（一個）\n\n已包含BVI政府費用",
        "content_cn": "成立全新英属处女岛公司\n服务内容包含：\n查册公司名称（英文名称）\n提供BVI注册地址\nBVI公司注册代理（一年）\n公司注册登记证\n公司董事、股东及要员名册\n公司章程(6本)\n公司空白股票正本（10张）\n制作公司印章（金属钢章、签字章）\n公司文件盒（一个）\n\n已包含BVI费用",
        "price": 19500,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 19500,
        "locale_name": "BVI limited company - Package B",
        "service_category": {
            "id": 2,
            "name": "BVI",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 1,
            "name": "limited_company",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 4,
        "service_category_id": 2,
        "service_subcategory_id": 1,
        "name": "BVI.limited_company.package_a",
        "service_fees": [
            {
                "text": "Provision of registered office",
                "fee": 5800
            },
            {
                "text": "Provision of registered agent",
                "fee": 4110
            },
            {
                "text": "BVI Government license fee",
                "fee": 4318
            },
            {
                "text": "Economic Substance Annual Reporting for BVI company @if(!empty($esar_year)) in {{ $esar_year }} @endif",
                "fee": 3000
            },
            {
                "text": "Annual return fee",
                "fee": 2000
            }
        ],
        "service_period": "@if(!empty($start_date) && !empty($end_date))\nTo Professional Service rendered as follows : -\nCompany incorporated in British Virgin Islands Annual fee for the period from {{ $start_date }} to {{ $end_date }}\n@endif",
        "service_payload": null,
        "content_en": "Buy a existing British Virgin Islands Company Package\nDetails\nProvide BVI registered address\nBVI company registration agent (one year)\nCompany registration certificate\nList of Directors, Shareholders and key personnel of the company\nArticles of Association (6 copies)\nOriginal blank company stock certificates (10 sheets)\nProduction of company seal (metal steel seal, signature seal)\nCompany document box (One Box)\n\nBVI government fees included",
        "content_tc": "購買現成英屬處女島公司\n服務內容包含：\n提供BVI註冊地址\nBVI公司註冊代理（一年）\n公司註冊登記證\n公司董事、股東及要員名冊\n公司章程(6本)\n公司空白股票正本（10張）\n製作公司印章（金屬鋼章、簽名章）\n公司文件盒（一個）\n\n已包含BVI政府費用",
        "content_cn": "购买现成英属处女岛公司套餐\n服務內容包含：\n提供BVI注册地址\nBVI公司注册代理（一年）\n公司注册登记证\n公司董事、股东及要员名册\n公司章程(6本)\n公司空白股票正本（10张）\n制作公司印章（金属钢章、签名章）\n公司文件盒（一个）\n\n已包含BVI费用",
        "price": 18000,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 18000,
        "locale_name": "BVI limited company - Package A",
        "service_category": {
            "id": 2,
            "name": "BVI",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 1,
            "name": "limited_company",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 3,
        "service_category_id": 1,
        "service_subcategory_id": 1,
        "name": "hongkong.limited_company.package_c",
        "service_fees": [
            {
                "text": "Provision of registered office",
                "fee": 5800
            },
            {
                "text": "Provision of registered agent",
                "fee": 4110
            },
            {
                "text": "BVI Government license fee",
                "fee": 4318
            },
            {
                "text": "Economic Substance Annual Reporting for BVI company @if(!empty($esar_year)) in {{ $esar_year }} @endif",
                "fee": 3000
            },
            {
                "text": "Annual return fee",
                "fee": 2000
            }
        ],
        "service_period": "@if(!empty($start_date) && !empty($end_date))\nTo Professional Service rendered as follows : -\nCompany incorporated in British Virgin Islands Annual fee for the period from {{ $start_date }} to {{ $end_date }}\n@endif",
        "service_payload": null,
        "content_en": "Establish a Hong Kong limited company + Virtual office service (1 year)\nDetails\nCompany name search\nApply for company registration certificate\nApply for business registration certificate\nPrepare company articles of association (7 copies)\nProduction of company seals (metal steel seals, medallion seals, signature seals)\nDeclaration of first director, shareholder, secretary and registered address\nLegal thin book\nA thin copy of the company's stock (20 sheets)\n\nGovernment fees included\n\nVirtual Office：\nUse WA Office\nLetter\nTelephone\nSecretary\nVoice Message",
        "content_tc": "成立香港有限公司 + 虛擬辦公司服務（1年）\n服務內容如下：\n公司名稱查冊\n申請公司註冊證書\n申請商業登記證\n編制公司章程（7本）\n製作公司印章（金屬鋼章、圓章、簽字章）\n申報首任董事、股東、秘書及註冊地址\n法定薄一本\n公司股票薄一本（20張）\n\n已包含政府費用\n\n虛擬辦公室服務內容如下：\n使用WA地址作為公司註冊地址\n無限代簽收信件，並及時做出通知\n獨立電話號碼\n電話秘書以貴公司名義代接聽電話\n主動通知閣下有關來電及口訊",
        "content_cn": "成立香港有限公司 + 虚拟办公司服务（1年）\n服務內容如下：\n公司名称查册\n申请公司注册证书\n申请商业登记证\n编制公司章程（7本）\n制作公司印章（金属钢章、圆章、签字章）\n申报首任董事、股东、秘书及注册地址\n法定薄一本\n公司股票薄一本（20张）\n\n已包含政府费用\n\n虚拟办公室：\n使用WA地址作為公司註冊地址-簡\n無限代簽收信-簡\n独立电话号码<\n电话秘书以贵公司名义代接听电话\n主动通知阁下有关来电及口讯",
        "price": 19000,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 19000,
        "locale_name": "Hong Kong limited company - Package C",
        "service_category": {
            "id": 1,
            "name": "hongkong",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 1,
            "name": "limited_company",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 2,
        "service_category_id": 1,
        "service_subcategory_id": 1,
        "name": "hongkong.limited_company.package_b",
        "service_fees": [
            {
                "text": "Provision of registered office",
                "fee": 5800
            },
            {
                "text": "Provision of registered agent",
                "fee": 4110
            },
            {
                "text": "BVI Government license fee",
                "fee": 4318
            },
            {
                "text": "Economic Substance Annual Reporting for BVI company @if(!empty($esar_year)) in {{ $esar_year }} @endif",
                "fee": 3000
            },
            {
                "text": "Annual return fee",
                "fee": 2000
            }
        ],
        "service_period": "@if(!empty($start_date) && !empty($end_date))\nTo Professional Service rendered as follows : -\nCompany incorporated in British Virgin Islands Annual fee for the period from {{ $start_date }} to {{ $end_date }}\n@endif",
        "service_payload": null,
        "content_en": "Establish a Hong Kong limited company + Virtual office service (1 year)\nDetails\nCompany name search\nApply for company registration certificate\nApply for business registration certificate\nPrepare company articles of association (7 copies)\nProduction of company seals (metal steel seals, medallion seals, signature seals)\nDeclaration of first director, shareholder, secretary and registered address\nLegal thin book\nA thin copy of the company's stock (20 sheets)\n\nVirtual office services include:\nUse WA office address as company registration address\nUnlimited acceptance for signed letters and prompt notification\n\nGovernment fees included",
        "content_tc": "成立香港有限公司 + 虛擬辦公司服務（1年）\n服務內容如下：\n公司名稱查冊\n申請公司註冊證書\n申請商業登記證\n編制公司章程（7本）\n製作公司印章（金屬鋼章、圓章、簽字章）\n申報首任董事、股東、秘書及註冊地址\n法定薄一本\n公司股票薄一本（20張）\n\n已包含政府費用\n\n虛擬辦公室服務內容如下：\n使用WA地址作為公司註冊地址\n無限代簽收信件，並及時做出通知",
        "content_cn": "成立香港有限公司 + 虚拟办公司服务（1年）\n服務內容如下：\n公司名称查册\n申请公司注册证书\n申请商业登记证\n编制公司章程（7本）\n制作公司印章（金属钢章、圆章、签字章）\n申报首任董事、股东、秘书及注册地址\n法定薄一本\n公司股票薄一本（20张）\n\n已包含政府费用\n\n虚拟办公室服务内容如下：\n使用WA地址作为公司注册地址\n无限代签收信件，并及时做出通知",
        "price": 17500,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 17500,
        "locale_name": "Hong Kong limited company - Package B",
        "service_category": {
            "id": 1,
            "name": "hongkong",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 1,
            "name": "limited_company",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    },
    {
        "id": 1,
        "service_category_id": 1,
        "service_subcategory_id": 1,
        "name": "hongkong.limited_company.package_a",
        "service_fees": [
            {
                "text": "Provision of registered office",
                "fee": 5800
            },
            {
                "text": "Provision of registered agent",
                "fee": 4110
            },
            {
                "text": "BVI Government license fee",
                "fee": 4318
            },
            {
                "text": "Economic Substance Annual Reporting for BVI company @if(!empty($esar_year)) in {{ $esar_year }} @endif",
                "fee": 3000
            },
            {
                "text": "Annual return fee",
                "fee": 2000
            }
        ],
        "service_period": "@if(!empty($start_date) && !empty($end_date))\nTo Professional Service rendered as follows : -\nCompany incorporated in British Virgin Islands Annual fee for the period from {{ $start_date }} to {{ $end_date }}\n@endif",
        "service_payload": null,
        "content_en": "Establish a Hong Kong limited company\nDetails\nCompany name search\nApply for company registration certificate\nApply for business registration certificate\nPrepare company articles of association (7 copies)\nProduction of company seals (metal steel seals, medallion seals, signature seals)\nDeclaration of first director, shareholder, secretary and registered address\nLegal thin book\nA thin copy of the company's stock (20 sheets)\n\nGovernment fees included",
        "content_tc": "成立香港有限公司\n服務內容如下：\n公司名稱查冊\n申請公司註冊證書\n申請商業登記證\n編制公司章程（7本）\n製作公司印章（金屬鋼章、圓章、簽字章）\n申報首任董事、股東、秘書及註冊地址\n法定薄一本\n公司股票薄一本（20張）\n\n已包含政府費用",
        "content_cn": "成立香港有限公司\n服務內容如下：\n公司名称查册\n申请公司注册证书\n申请商业登记证\n编制公司章程（7本）\n制作公司印章（金属钢章、圆章、签字章）\n申报首任董事、股东、秘书及注册地址\n法定薄一本\n公司股票薄一本（20张）\n\n已包含政府费用",
        "price": 12500,
        "discount": null,
        "discount_start_at": null,
        "discount_end_at": null,
        "is_hidden": 0,
        "is_void": 0,
        "created_by": 0,
        "updated_by": 0,
        "created_at": "2024-08-07 16:18:22",
        "updated_at": "2024-08-07 16:18:22",
        "current_price": 12500,
        "locale_name": "Hong Kong limited company - Package A",
        "service_category": {
            "id": 1,
            "name": "hongkong",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        },
        "service_subcategory": {
            "id": 1,
            "name": "limited_company",
            "is_hidden": 0,
            "is_void": 0,
            "created_by": 0,
            "updated_by": 0,
            "created_at": "2024-08-07 16:18:22",
            "updated_at": "2024-08-07 16:18:22"
        }
    }
]


export let resp_services = new Proxy(
    {
        value: services
    }, {
    get(target, prop, rx) {
        return target
    },
    set(target, prop, newVal) {
        target[prop] = newVal
        return true
    }
})


// URL
export const URL_FILE_PREFIX = 'https://wellalliance.com.hk'
export const URL_API_PREFIX = 'https://wellalliance.com.hk/api/'
// export const URL_FILE_PREFIX = 'https://wellalliance.com.hk'
// export const URL_API_PREFIX = 'https://wellalliance.com.hk/api/'